package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class CashBox(
    val id: Int,
    val name: String,
    val balance: Int? = null,
    val is_main: Int? = null,
    val organization: String? = null
) {
    val isMain: Boolean get() = is_main == 1
}